<template>
    <div>
		<input type="hidden" :value="Totales">
		<input type="hidden" :value="bloker">

        <table class="table-venta-01">
            <thead>
                <tr>
                    <th class="sticky marca" scope="col">Concepto</th>
                    <th scope="col">Trimeste 1</th>
                    <!-- <th scope="col">#Propuestas</th> -->
                    <th scope="col">Trimestre 2</th>
                    <!-- <th scope="col">#Propuestas</th> -->
                    <th scope="col">Trimestre 3</th>
                    <!-- <th scope="col">#Propuestas</th> -->
                    <th scope="col">Trimestre 4</th>
                    <!-- <th scope="col">#Propuestas</th> -->
                    <th scope="col">Total</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(item,index) in ListaDetalle" :key="index">
                <td class="sticky">
					<div class="row">
						<div class="col-lg-7 mt-1">
							<span class="bold" style="font-size:16px">{{item.Nombre}}</span>
						</div>
						<div class="col-lg-5">
							<button @click="AbrirModalDetalle(item.Data.Anio,item.IdConfigS,item.Data.IdVendedor,item.Data.ListaDetalle,item.Data.UnoT,item.Data.DosT,item.Data.TresT,item.Data.CuatroT)" class="btn btn-outline-secondary" style="border:0;font-size:20px !important" v-b-tooltip.hover.top title="Ver Detalles" data-toggle="modal" :data-target="'#planform'"><i style="" class="fa fa-plus-circle"></i></button>
						</div>
					</div>
				</td>
				<!-- <td class="sticky">{{item.Nombre}} <button @click="AbrirModalDetalle(item)" class="btn btn-01" data-toggle="modal" :data-target="'#planform'"><i class="fa fa-plus"></i></button></td> -->
                    <td >
                        <vue-numeric :disabled="true" placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.Data.UnoT"/>
					</td>
                    <!-- <td >
						<vue-numeric :disabled="localBlocker" placeholder="0" disabled class="form-control form-finanza form-control-sm text-center bold" currency="" separator=","  v-model="item.Data.UnoP"/>
					</td> -->
                    <td>
                        <vue-numeric :disabled="true" placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.Data.DosT"/>
                    </td>
                    <!-- <td>
						<vue-numeric :disabled="localBlocker" placeholder="0" disabled class="form-control form-finanza form-control-sm text-center bold" currency="" separator=","  v-model="item.Data.DosP"/>
					</td> -->
                    <td>
						<vue-numeric :disabled="true" placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.Data.TresT"/>
					</td>
                    <!-- <td>
						<vue-numeric :disabled="localBlocker" placeholder="0" disabled class="form-control form-finanza form-control-sm text-center bold" currency="" separator=","  v-model="item.Data.TresP"/>
					</td> -->
                    <td>
						<vue-numeric :disabled="true" placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.Data.CuatroT"/>
					</td>
                    <!-- <td>
						<vue-numeric :disabled="localBlocker" placeholder="0" disabled class="form-control form-finanza form-control-sm text-center bold" currency="" separator=","  v-model="item.Data.CuatroP"/>
					</td> -->
                    <td>
						<vue-numeric :disabled="true"  placeholder="$ 0.00" class="form-control form-finanza form-control-sm text-center bold" currency="$" separator="," :precision="2" v-model="item.Data.TotalAnual"/>
					</td>
                </tr>

            </tbody>
            <tfoot>
                <tr>
                    <td class="color-01 bold sticky marca">Totales</td>
                    <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="Trimestre1"></vue-numeric></td>
                    <!-- <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="" separator=","  v-model="Propuesta1"></vue-numeric></td> -->
                    <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="Trimestre2"></vue-numeric></td>
                    <!-- <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="" separator=","  v-model="Propuesta2"></vue-numeric></td> -->
                    <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="Trimestre3"></vue-numeric></td>
                    <!-- <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="" separator=","  v-model="Propuesta3"></vue-numeric></td> -->
                    <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="Trimestre4"></vue-numeric></td>
                    <!-- <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="" separator=","  v-model="Propuesta4"></vue-numeric></td> -->
                    <td><vue-numeric disabled class="form-control form-finanza form-control-sm color-01 bold text-center" currency="$" separator="," :precision="2" v-model="TotalGral"></vue-numeric></td>
                </tr>
            </tfoot>
        </table>
		<Modal :Nombre="ModalNombre" :NameModal="'planform'" :size="'modal-xl'" :pEmitSeccion="'planform'" :poBtnSave="oBtnSave">
        	<template slot="Form">
        	    <FinancieraForm :pEmitSeccion="'planform'"></FinancieraForm>
        	</template>
    	</Modal>
    </div>
</template>

<script>
import FinancieraForm from "./PlanForm.vue";
import Modal from '@/components/Cmodal.vue';
export default {
    props:['ListaDetalle','pBloker'],
	components:{FinancieraForm,Modal},
    data() {
        return {
            Trimestre1:0,
            Trimestre2:0,
            Trimestre3:0,
            Trimestre4:0,
            Propuesta1:0,
            Propuesta2:0,
            Propuesta3:0,
            Propuesta4:0,
            TotalGral:0,
            price:'',
            Decimal:1,
			localBlocker:false,
			oBtnSave:{
				nombreModal:"planform",
				EmitSeccion:"planform",
				txtSave:"Confirmar"
			},
			ModalNombre:'Plan'
        }
    },
    methods: {
       //formateando numeros
    	formatNumber(num,prefix){
    	   num = Math.round(parseFloat(num)*Math.pow(10,2))/Math.pow(10,2)
    	   prefix = prefix || '';
    	   num += '';
    	   var splitStr = num.split('.');
    	   var splitLeft = splitStr[0];
    	   var splitRight = splitStr.length > 1 ? '.' + splitStr[1] : '.00';
    	   splitRight = splitRight + '00';
    	   splitRight = splitRight.substr(0,3);
    	   var regx = /(\d+)(\d{3})/;
    	   while (regx.test(splitLeft)) {
    	       splitLeft = splitLeft.replace(regx, '$1' + ',' + '$2');
    	   }
    	   return prefix + splitLeft + splitRight;
    	},

		AbrirModalDetalle(Anio,IdConfigS,IdVendedor,DetalleCuenta,PrimerT,SegundoT,TercerT,CuartoT){
			switch (Number(IdConfigS)) {
				case 1:
					this.ModalNombre='Mantenimiento';
					break;
				case 2:
					this.ModalNombre='Servicio';
					break;
				case 3:
					this.ModalNombre='Proyecto';
					break;
				default:
					break;
			}
            this.bus.$emit('PassDetallesCuenta',Anio,IdConfigS,IdVendedor,DetalleCuenta,PrimerT,SegundoT,TercerT,CuartoT);
            // this.bus.$emit('CambiarNombreModal',Descripcion);
        }
		// AbrirModalDetalle(item){
		// 	console.log(item);
        // }

    },
    created() {
		this.bus.$off('IgualarTrimestres');
		this.bus.$on('IgualarTrimestres',(Anio,IdConfigS,IdVendedor,PrimerT,SegundoT,TercerT,CuartoT)=>{
            let index=this.ListaDetalle.findIndex((element)=>element.IdConfigS==IdConfigS);
            this.ListaDetalle[index].Data.UnoT=PrimerT;
            this.ListaDetalle[index].Data.DosT=SegundoT;
            this.ListaDetalle[index].Data.TresT=TercerT;
            this.ListaDetalle[index].Data.CuatroT=CuartoT;
            $('#planform').modal("hide");
        });
    },
    computed: {
		Totales () {
			this.Trimestre1=0;
			this.Trimestre2=0;
			this.Trimestre3=0;
			this.Trimestre4=0;
			this.TotalGral=0;
			this.Propuesta1=0;
			this.Propuesta2=0;
			this.Propuesta3=0;
			this.Propuesta4=0;
			let fixed=0;

            for ( let i =0;i<this.ListaDetalle.length;i++ ) {
				let Total =0;

                this.ListaDetalle[i].Data.UnoP=0;
                if (this.ListaDetalle[i].Data.UnoT !== '') {

                    this.Trimestre1 +=parseFloat( this.ListaDetalle[i].Data.UnoT);
                    Total +=parseFloat( this.ListaDetalle[i].Data.UnoT);

                    if (this.ListaDetalle[i].Data.ValorPromedio !== '' && this.ListaDetalle[i].Data.PorcentajeBCierre !== '')  {
                    let y = (parseFloat(this.ListaDetalle[i].Data.UnoT)  /parseFloat(this.ListaDetalle[i].Data.ValorPromedio) ) * 100 ;
                    let Prop=parseFloat(y) /parseFloat(this.ListaDetalle[i].Data.PorcentajeBCierre);
                        if(Prop=='Infinity' || isNaN(Prop)==true){
                            Prop =0;
                        }
                    this.ListaDetalle[i].Data.UnoP= Prop.toFixed(fixed);
                    this.Propuesta1 +=parseFloat(Prop.toFixed(fixed));
                    }

                }

                this.ListaDetalle[i].Data.DosP=0;
				if (this.ListaDetalle[i].Data.DosT !='') {
					this.Trimestre2 +=parseFloat( this.ListaDetalle[i].Data.DosT);
					Total   +=parseFloat( this.ListaDetalle[i].Data.DosT);

					if (this.ListaDetalle[i].Data.ValorPromedio !='' && this.ListaDetalle[i].Data.PorcentajeBCierre !='') {
						let y 		= (parseFloat(this.ListaDetalle[i].Data.DosT)  /parseFloat(this.ListaDetalle[i].Data.ValorPromedio) ) * 100 ;
						let Prop 	= parseFloat(y) /parseFloat(this.ListaDetalle[i].Data.PorcentajeBCierre);
                        if(Prop=='Infinity' || isNaN(Prop)==true){
                            Prop =0;
                        }
                    	this.ListaDetalle[i].Data.DosP= Prop.toFixed(fixed);
                     	this.Propuesta2 +=parseFloat(Prop.toFixed(fixed));
                    }

                }

				this.ListaDetalle[i].Data.TresP=0;
				if (this.ListaDetalle[i].Data.TresT !='') {
					 this.Trimestre3 +=parseFloat( this.ListaDetalle[i].Data.TresT);
					 Total   +=parseFloat( this.ListaDetalle[i].Data.TresT);

					 if (this.ListaDetalle[i].Data.ValorPromedio !='' && this.ListaDetalle[i].Data.PorcentajeBCierre !='') {
						 let y = (parseFloat(this.ListaDetalle[i].Data.TresT)  /parseFloat(this.ListaDetalle[i].Data.ValorPromedio) ) * 100 ;
						 let Prop=parseFloat(y) /parseFloat(this.ListaDetalle[i].Data.PorcentajeBCierre);
						 if(Prop=='Infinity' || isNaN(Prop)==true) {
                            Prop =0;
						 }
						 this.ListaDetalle[i].Data.TresP= Prop.toFixed(fixed);
						 this.Propuesta3 +=parseFloat(Prop.toFixed(fixed));
                    }
                }

                this.ListaDetalle[i].Data.CuatroP=0;
                if (this.ListaDetalle[i].Data.CuatroT !='') {
                this.Trimestre4 +=parseFloat( this.ListaDetalle[i].Data.CuatroT);
                Total   +=parseFloat( this.ListaDetalle[i].Data.CuatroT);

				if (this.ListaDetalle[i].Data.ValorPromedio !='' && this.ListaDetalle[i].Data.PorcentajeBCierre !='') {
                    let y = (parseFloat(this.ListaDetalle[i].Data.CuatroT)  /parseFloat(this.ListaDetalle[i].Data.ValorPromedio) ) * 100 ;
                    let Prop=parseFloat(y) /parseFloat(this.ListaDetalle[i].Data.PorcentajeBCierre);
                        if(Prop=='Infinity' || isNaN(Prop)==true){
                            Prop =0;
                        }
                    this.ListaDetalle[i].Data.CuatroP= Prop.toFixed(fixed);
                        this.Propuesta4 +=parseFloat(Prop.toFixed(fixed));
                    }
                }
                this.TotalGral +=parseFloat(Total);
                this.ListaDetalle[i].Data.TotalAnual =parseFloat(Total);
            }

			return this.ListaDetalle;

        },

		bloker() {
			if(this.pBloker !== undefined){
				this.localBlocker = this.pBloker;
			}
		}
    },


}
</script>
